import script from "./MGWalkthrough.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGWalkthrough.vue?vue&type=script&setup=true&lang=ts"

import "./MGWalkthrough.vue?vue&type=style&index=0&id=d16e98c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d16e98c6"]])

export default __exports__